import { useState } from "react";
import axios from "axios";
import { Lock } from "lucide-react";
import Logo from "../Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin({ onAuthed }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await axios.post(`${API}/admin/login`, { pin: pin.trim() }, { withCredentials: true });
      onAuthed();
    } catch {
      setError("Wrong PIN — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-cream px-5">
      <form
        data-testid="admin-login-form"
        onSubmit={submit}
        className="w-full max-w-xs rounded-2xl border border-gold-faint bg-ivory p-8 text-center shadow-[0_30px_60px_-30px_rgba(26,25,23,0.25)]"
      >
        <Logo className="mx-auto h-12 w-12" />
        <h1 className="mt-4 font-serif text-2xl font-semibold">Admin</h1>
        <p className="mt-1 text-xs uppercase tracking-[0.3em] text-gold-dark">Vayu Celebrations</p>
        <div className="relative mt-6">
          <Lock className="absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gold-dark" />
          <input
            data-testid="admin-pin-input"
            type="password"
            inputMode="numeric"
            required
            autoFocus
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            placeholder="Enter PIN"
            className="w-full rounded-md border border-gold-faint bg-cream py-3 pl-10 pr-4 text-center tracking-[0.4em] outline-none focus:border-gold"
          />
        </div>
        {error && (
          <p data-testid="admin-login-error" className="mt-3 text-xs text-red-600">
            {error}
          </p>
        )}
        <button
          data-testid="admin-login-button"
          type="submit"
          disabled={busy}
          className="mt-5 w-full rounded-full bg-gold py-3 text-xs font-semibold uppercase tracking-[0.25em] text-night transition-colors hover:bg-gold-light disabled:opacity-60"
        >
          {busy ? "Checking..." : "Unlock"}
        </button>
      </form>
    </div>
  );
}
